<!-- This card handles apply  content. Used in details  pages -->
<div class="apply-card">
    <ion-card-header class="apply-card-header ion-text-center" lines="none">
        <ion-card-title
            [ngClass]="{
                'application-title': status !== undefined || null
            }"
        >
            <div *ngIf="!(hidePrices$ | async) && showProgramPrice" class="section-title program-price">
                <span *ngIf="!showHourlyTotal" [innerHTML]="program | splitPrice : detectedChangeRef : null : profile"></span>
                <span *ngIf="showHourlyTotal">Total: ${{ hourlyTotal }} USD</span>
            </div>
            <div *ngIf="showCustomPrice && !showProgramPrice" class="section-title program-price">
                <span
                    ><b class="bold-text">{{ customPrice }}</b></span
                >
                <br />
                <small class="total-program-price-hourly" *ngIf="showHourlyTotal">(Total: ${{ totalProgramPrice }} USD)</small>
            </div>
            <div *ngIf="hasCustomAvailability === false && profile?.fieldofstudy !== 'Nurse Practitioner'" class="program-duration-container">
                <b class="ion-text-center bold-text">{{ (toolService.content | async)?.program?.components?.programApply?.programapplybox?.duration }} </b>
            </div>
            <div *ngIf="status?.application?.id !== null || undefined" class="application-starttime bold-text">
                {{ status?.application.type }}<br />
                {{ status?.application.startdate | date }} -
                {{ status?.application.enddate | date }}
            </div>
        </ion-card-title>
        <ion-card-title *ngIf="program?.program?.price !== null" class="section-title program-price ion-text-center">
            <p class="card-text amount-text" *ngIf="application">
                {{ (toolService.content | async)?.program?.components?.programApply?.programapplybox?.carditle }}
                <span class="bold-text">${{ program?.price }} USD</span>
            </p>
        </ion-card-title>
        <hr />
    </ion-card-header>
    <ion-card-content class="ion-text-center desktop-apply-button">
        <div *ngIf="!status && application_form">
            <div class="type-warning-container" *ngIf="(isManager$ | async) === false && typeNotFoundForUser">
                <div class="type-warning-box">
                    <fa-icon [icon]="icons.faExclamationCircle"></fa-icon>
                    <p>You do not have an applicable field of study to apply to this program.</p>
                </div>
            </div>
            <form [formGroup]="application_form" (ngSubmit)="submit()" autocomplete="off">
                <ion-list>
                    <ion-item lines="none" (click)="openProgramModal('type')">
                        <ion-label class="form-title apply-label" position="stacked">Type</ion-label>
                        <ion-input
                            placeholder="Select a Rotation Type"
                            readonly
                            class="apply-select-b"
                            id="type"
                            [value]="programType"
                            formControlName="type"
                            [disabled]="typeNotFoundForUser"
                            data-lpignore="true"
                        ></ion-input>
                    </ion-item>
                    <ion-item lines="none" [disabled]="noAvail" (click)="openProgramModal('time')">
                        <ion-label class="form-title apply-label" position="stacked">Start Date</ion-label>
                        <!-- {{programTime | json}} -->
                        <ion-input
                            placeholder="Select a Rotation Start Date"
                            readonly
                            class="apply-select"
                            [value]="programTime"
                            formControlName="start"
                            style="display: none"
                            [disabled]="noAvail"
                            data-lpignore="true"
                        ></ion-input>
                        <ion-input
                            placeholder="Select a Rotation Start Date"
                            readonly
                            class="apply-select"
                            [value]="programTime?.display"
                            id="programTime?.startdate"
                            [disabled]="noAvail"
                            (ionChange)="updatePrice($event)"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="detectedChangeRef"
                            data-lpignore="true"
                        ></ion-input>
                    </ion-item>
                    <ion-item lines="none" [disabled]="noAvail || managementHidePrice" *ngIf="profile?.fieldofstudy === 'Nurse Practitioner'">
                        <ion-label class="form-title apply-label" position="stacked">Hours Requesting (Minimum 40 hours)</ion-label>
                        <ion-input
                            placeholder="Enter Total Hours Requesting"
                            class="apply-select"
                            [(ngModel)]="requestedHours"
                            (ionChange)="updateHourlyPricing($event)"
                            [ngModelOptions]="{ standalone: true }"
                            [disabled]="noAvail || managementHidePrice"
                            id="hours"
                            type="number"
                            data-lpignore="true"
                            [disabled]="noAvail || managementHidePrice || !programTime?.startdate"
                        ></ion-input>
                    </ion-item>

                    <p *ngIf="noAvail">
                        {{ (toolService.content | async)?.program?.components?.programApply?.programapplybox?.notavailable }}
                        <a class="link-anchor" href="mailto: {{ (toolService.content | async)?.basic?.email?.main }}">{{
                            (toolService.content | async)?.basic?.email?.main
                        }}</a
                        >.
                    </p>
                    <div class="button-row">
                        <ion-button
                            id="ProgramApplyButton"
                            class="half-button submit-button"
                            type="submit"
                            [disabled]="noAvail || booking.submitting || profile?.type === 'Hosting'"
                        >
                            {{ (toolService.content | async)?.basic?.button?.apply }}
                        </ion-button>
                        <ion-button
                            id="ProgramAddToItinerary"
                            class="half-button submit-button"
                            *ngIf="enableItineraries"
                            (click)="addToItinerary()"
                            color="secondary"
                            [disabled]="noAvail || this.booking.submitting"
                            >+Add to Itinerary
                        </ion-button>
                    </div>
                    <div *ngIf="enableItineraries" class="ion-text-center">
                        <ion-button style="text-decoration: underline; font-size: 0.95em" (click)="openItineraryModal($event)" fill="clear" shape="round">
                            What is my Itinerary?
                            <fa-icon style="margin-left: 0.2em; vertical-align: middle" [icon]="icons?.faQuestionCircle"></fa-icon>
                        </ion-button>
                    </div>
                </ion-list>
            </form>
        </div>
    </ion-card-content>
</div>
